import { render, staticRenderFns } from "./header-icon.vue?vue&type=template&id=4b80566e&functional=true&"
import script from "./header-icon.vue?vue&type=script&lang=js&"
export * from "./header-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports